import React from 'react';

const Banner = () => {
  return (
    <div className="results__banner">
      <div className="is-inner">
        <div className="is-title">Get faster with Netlify</div>
        <div className="is-subtitle">Get the best performance &amp; security with Netlify.</div>
        <ul>
          <li className="results__banner__item is-featured"><a href="https://app.netlify.com/signup">Create your free account</a></li>
          <li className="results__banner__item"><a href="https://www.netlify.com/features">Explore the features</a></li>
        </ul>
      </div>
    </div>
  );
};

export default Banner;



// WEBPACK FOOTER //
// ./src/components/results/Banner.js